// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getPurchaseOrderAuditEvents } from '@/audit/api/get-purchase-order-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { purchaseOrderAuditQueryKey } from '@/purchase-order/query-keys';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  purchaseOrderKey: string;
}

/**
 * Suspends while fetching the audit events for a single purchase order and
 * renders them in reverse chronological order using the shared
 * AuditEventListItem.
 */
export function PurchaseOrderAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: purchaseOrderAuditQueryKey(props.purchaseOrderKey),
    queryFn: () => getPurchaseOrderAuditEvents(props.purchaseOrderKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this purchase order yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
